import { AvatarGroup, ClippedContent, ControlledPopup, DateTimeUtils, EllipsisDropdown, Table } from "dyl-components";
import { useState } from "react";
import HolidayScheduleSubRow from "./HolidayScheduleSubRow";
import { DropdownItem, Header } from "semantic-ui-react";
import "../index.scss";
const HolidayScheduleRow = ({ holidaySchedule = {}, onDelete, onEdit, onDuplicate, isDuplicateDisable }) => {
    const { id, created, updated, created_user, label, description, updated_user, routing_rules } = holidaySchedule;
    const [isCollapsed, setIsCollapsed] = useState(true);

    const handleToggle = async () => {
        setIsCollapsed(!isCollapsed)
    };
    return (
        <Table.CollapsibleRow
            onToggle={handleToggle}
            collapsed={isCollapsed}
            togglePos={0}
            toggleHidden={false}
            toggleDisabled={routing_rules.length === 0}
            subrowContent={[
                <HolidayScheduleSubRow
                    routingRules={routing_rules}
                />
            ]}
        >
            <Table.Cell>
                {created && (
                    <>
                        <div><b>{DateTimeUtils.formatEpoch(created, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                        <div>{DateTimeUtils.formatEpoch(created, DateTimeUtils.TIME_FORMAT)}</div>
                    </>
                )}
            </Table.Cell>
            <Table.Cell>
                {updated && (
                    <>
                        <div><b>{DateTimeUtils.formatEpoch(updated, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                        <div>{DateTimeUtils.formatEpoch(updated, DateTimeUtils.TIME_FORMAT)}</div>
                    </>
                )}
            </Table.Cell>
            <Table.Cell className="HolidayScheduleTable__MediumFixedWidth">
                <ClippedContent>
                    {label}
                </ClippedContent>
            </Table.Cell>
            <Table.Cell className="HolidayScheduleTable__MediumFixedWidth">
                <ClippedContent>
                    {description}
                </ClippedContent>
            </Table.Cell>
            <Table.Cell>
                <AvatarGroup
                    persons={[{
                        first_name: created_user?.first_name,
                        last_name: created_user?.last_name,
                        email: created_user?.email,
                        inactive: !created_user?.active,
                    }]}
                    limit={1}
                    size="3em"
                />
            </Table.Cell>
            <Table.Cell>
                <AvatarGroup
                    persons={[{
                        first_name: updated_user?.first_name,
                        last_name: updated_user?.last_name,
                        email: updated_user?.email,
                        inactive: !updated_user?.active,
                    }]}
                    limit={1}
                    size="3em"
                />
            </Table.Cell>
            <Table.Cell>
                <EllipsisDropdown>
                    <DropdownItem
                        text={"Edit"}
                        icon={'fa-solid fa-pencil'}
                        onClick={() => onEdit(id)}
                    />
                    <DropdownItem
                        text="Duplicate"
                        icon="fas fa-copy"
                        onClick={() => onDuplicate(id)}
                        disabled={isDuplicateDisable}
                    />
                    <ControlledPopup
                        header={
                            <Header as='h4' textAlign='center'>
                                Are you sure?
                                <Header.Subheader style={{ marginTop: 5 }}>
                                    You cannot undo delete actions.
                                </Header.Subheader>
                            </Header>
                        }

                        trigger={
                            <DropdownItem
                                text={"Delete"}
                                icon="fa-solid fa-trash"
                                onClick={() => { }}
                            />
                        }
                        onConfirm={() => onDelete(id)}
                        position="bottom center"
                        inverted
                    />
                </EllipsisDropdown>
            </Table.Cell>
        </Table.CollapsibleRow>
    )
}

export default HolidayScheduleRow;